import React, { useEffect } from 'react'
import { History, Location } from 'history'
import { match as Match } from 'react-router'
import { Row, Col } from 'styled-bootstrap-grid'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'

import Wizard from '../../../components/Wizard'
import { Layout, Box } from '../../../components/Page/Layout'
import { Page } from '../../../components/Page'
import { selectedFlow } from '../../../features/flow/selectors'
import { FlowActions } from '../../../features/flow/actions'
import { AddFlowBase } from './AddFlowBase'
import { AddFlowSections } from './AddFlowSections'
import { AddFlowConfiguration } from './AddFlowConfiguration'
import { AddFlowHooks } from './AddFlowHooks'

interface AddFlowContainerProps {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
  match?: Match<{ flow_id: string }>
}

export const AddFlowContainer: React.FC<AddFlowContainerProps> = ({ history, match }: AddFlowContainerProps) => {
  const flowId = _.get(match, 'params.flowId')

  const flow = useSelector(selectedFlow)
  const dispatch = useDispatch()

  useEffect(() => {
    // console.log(hookId)
    if (flowId) {
      dispatch(FlowActions.fetchFlowInfo(flowId))
      dispatch(FlowActions.updateFlowValidation({ isValid: true }))
    } else {
      dispatch(
        FlowActions.updateNewFlow({
          name: ''
        })
      )
    }
    return () => {
      dispatch(FlowActions.resetNewFlow())
      dispatch(FlowActions.updateFlowValidation({ isValid: false }))
    }
  }, [dispatch, flowId])

  const addNewFlow = () => {
    if (flow) {
      // console.log(flow)
      dispatch(FlowActions.startSavingFlow(flow))
    }
  }

  const components: JSX.Element[] = []

  components.push(<AddFlowBase key="addflowbase" close={history.goBack} />)
  components.push(<AddFlowSections key="addflowsections" close={history.goBack} />)
  components.push(<AddFlowHooks key="addflowhooks" close={history.goBack} />)
  components.push(<AddFlowConfiguration key="addflowconfiguration" addFlow={addNewFlow} />)

  return (
    <Page>
      <Layout>
        <Row>
          <Col xl={8} lg={10} xlOffset={2} lgOffset={1} md={12}>
            <Box>
              <Wizard stepCount={components.length}>{components}</Wizard>
            </Box>
          </Col>
        </Row>
      </Layout>
    </Page>
  )
}
